module.exports = __webpack_public_path__ + "img/n26.ff973458.png";